import AdvanceInitContainer from "../../Componant/DataTable/AdvanceInit";

const AdvanceInit = () => {
  return (
    <div className="page-body">
      <AdvanceInitContainer />
    </div>
  );
};

export default AdvanceInit;
